<div class="box-container">
  <ppl-icon svgIcon="logo"
            class="logo"
            height="56px"
            width="244px"></ppl-icon>
  <div class="box"
       [class.small]="small">
    <ng-content></ng-content>
  </div>
</div>
